// «Van 14 días de los 30. ¿Cuánto le cobro si quiere cancelar hoy?»
//
// El interés del programa corre por MESES: se genera entero al llegar el corte
// y antes de eso no se debe. Eso está bien y no se toca — es como lleva la
// cuenta el prestamista y como se le explica al cliente.
//
// Pero hay un momento donde hace falta otra cifra: el cliente que aparece a
// mitad de mes queriendo cancelar todo. Al prestamista no le sirve «no debe
// interés todavía» —lleva medio mes con la plata prestada— ni tampoco cobrarle
// el mes entero. Lo que hace de cabeza es una regla de tres: si van 14 de 30
// días, catorce treintavos del interés.
//
// ⚠️ Esto NO cambia ninguna cuenta del programa. No entra en la deuda, ni en la
// mora, ni en lo que se le cobra al cierre. Es una sugerencia para negociar, y
// vive aparte a propósito: el día que alguien la confunda con la deuda, que sea
// evidente que son dos cosas distintas.
//
// Va en la pantalla de Deuda, que la ve solo el prestamista. En el estado de
// cuenta que recibe el cliente NO aparece: dos cifras distintas de «si paga
// hoy» en el mismo mensaje es una discusión servida.

const DIA = 86400000;

const diaDe = (f) => {
  const d = f instanceof Date ? f : new Date(f);
  return isNaN(d.getTime()) ? null : Math.floor(d.getTime() / DIA);
};

export function estimadoPorDias(prestamo, estado, hasta = new Date()) {
  if (!estado || estado.modalidad === 'cuota_fija') return null;

  // Si el mes ya se dio por consumido —los últimos días antes del corte— el
  // interés completo YA está dentro de la deuda. Sumarle una parte encima sería
  // cobrarlo dos veces.
  if (estado.mesConsumido) return null;

  const proy = estado.proyeccion;
  if (!proy || !proy.desde || !proy.corte) return null;

  const dDesde = diaDe(proy.desde);
  const dCorte = diaDe(proy.corte);
  const dHoy = diaDe(hasta);
  if (dDesde === null || dCorte === null || dHoy === null) return null;

  const delPeriodo = dCorte - dDesde;
  const corridos = dHoy - dDesde;
  if (delPeriodo <= 0 || corridos <= 0) return null;

  // Nunca más del mes entero: si por alguna razón se pasó del corte, el tope
  // es el interés del mes y no una fracción mayor que uno.
  const parte = Math.min(1, corridos / delPeriodo);
  const interes = Math.round((proy.interesDelMes || 0) * parte);

  return {
    dias: corridos,
    diasDelPeriodo: delPeriodo,
    interesDelMes: Math.round(proy.interesDelMes || 0),
    interes,
    // Lo que tendría que entregar para quedar en cero hoy, con esos días.
    aPagar: Math.max(0, Math.round(estado.deudaTotal + interes)),
    // Y lo que dice el programa sin cobrar nada por los días corridos, que es
    // la cifra oficial y la que ve el cliente.
    sinCobrarDias: Math.round(estado.deudaTotal),
  };
}
